<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Pagar a Seac/Otras redes</b-card-header>
      <b-card-body>
        <div class="row form-group">
          <div class="col-md-12">
            <base-button type="success" @click="gestionarProveedores()">Gestionar redes</base-button>
          </div>
        </div>
        <div class="row form-group" v-if="proveedor == null">
          <div class="col-md-12">
            <div style="background-color: white; border-radius: 5px; border: #d6d4d4 1px solid">
              <div
                class="row"
                v-for="item in proveedores"
                @click="itemClicked(item)"
                v-bind:key="item.SupplierID"
                :value="item.SupplierID"
                style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
              >
                <div class="col-10" style="display: flex">
                  <img :src="item.Image" class="rounded-circle" style="width: 50px" alt />
                  <div style="margin-left: 10px;margin-top: 10px;">
                    <div>{{item.SupplierName}}</div>
                  </div>
                </div>
                <div class="col-2 text-right" style="padding-top: 10px; padding-right: 25px">></div>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div
            class="row form-group"
            style="background-color: white; padding: 5px; border-radius: 5px; margin-right: 0; margin-left: 0; border: #d6d4d4 1px solid"
          >
            <div class="col-10" style="display: flex;">
              <img :src="proveedor.Image" class="rounded-circle" style="width: 50px" alt />
              <div style="margin-left: 10px;margin-top: 10px;">
                <div>{{proveedor.SupplierName}}</div>
              </div>
            </div>
            <div class="col-2 text-right" style="padding-top: 10px; padding-right: 25px">
              <i class="fa fa-fw fa-times" style="cursor: pointer" @click="cleanSelected()"></i>
            </div>
          </div>

          <div class="row form-group">
            <div class="col-md-12">
              <label>Referencia proveedor</label>
              <base-input v-model="model.Aux" readonly></base-input>
            </div>
          </div>

          <div class="row form-group">
            <div class="col-md-12">
              <label>Observación de pago</label>
              <base-input v-model="model.Referencia"></base-input>
            </div>
          </div>

          <div class="row form-group">
            <div class="col-md-12">
              <label>Importe</label>
              <vue-numeric
                currency="$"
                v-bind:precision="2"
                decimal-separator="."
                thousand-separator=" "
                v-model="model.Importe"
                class="form-control"
              ></vue-numeric>
            </div>
          </div>

          <div class="row form-group">
            <div class="col-md-12">
              <save-button text="Pagar" @click="pagar"></save-button>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

import KitsCombo from "@/components/KitsCombo";
import KitsBusquedaSimple from "@/components/KitsBusquedaSimple";

export default {
  components: { KitsCombo, KitsBusquedaSimple },
  data() {
    return {
      model: { Referencia: "", Importe: 0, Aux: "" },
      proveedores: [],
      proveedor: null
    };
  },
  methods: {
    gestionarProveedores() {
      this.$router.push("gestionproveedores");
    },
    itemClicked(item) {
      this.proveedor = item;
      this.model.Aux = item.ReferenceValue;
    },
    cleanSelected() {
      this.proveedor = null;
    },
    pagar() {
      let context = this;
      if (this.model.Referencia == "" || this.model.Importe == 0) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "Debe completar todos los campos",
          context
        );
        return;
      }

      axiosHelpers.axiosPost(
        "Commerce/PayToSupplier",
        {
          SupplierID: context.proveedor.SupplierID,
          Amount: context.model.Importe,
          Aux: context.model.Aux,
          Reference: context.model.Referencia
        },
        context,
        function(data) {
          if (data.ResponseVM.Resultado) {
            notificationHelpers.showSuccess(
              "Exito",
              "Se realizó el pago a proveedor correctamente",
              context
            );
            context.model = { Referencia: "", Importe: 0, Aux: "" };
          }
        }
      );
    }
  },
  beforeMount: function() {
    let context = this;

    axiosHelpers.axiosPost(
      "Account/GetSuppliersByAccountID",
      {},
      this,
      function(data) {
        context.proveedores = data.ResponseVM.Items;
      }
    );
  }
};
</script>